module.exports = __webpack_public_path__ + "static/media/menu-back-medium.1b2fbfe8.jpg";